import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BuildIcon from '@mui/icons-material/Build';
import type { GoalTaskType } from '../../api/types';

/** Cart for a part to buy, wrench for a job to do. */
export function GoalTaskTypeIcon({ type }: { type: GoalTaskType }) {
  return type === 'buy' ? <ShoppingCartIcon fontSize="small" /> : <BuildIcon fontSize="small" />;
}
